export default function ComponentAnalysisDisplay({ analysis, statusType = "success" }) {
    const statusColors = {
        success: "text-emerald-600",
        warning: "text-amber-600",
        error: "text-red-600"
    };

    const statusBgColors = {
        success: "bg-emerald-50",
        warning: "bg-amber-50",
        error: "bg-red-50"
    };

    return (
        <div className={`text-xs space-y-1 p-2 rounded ${statusBgColors[statusType]}`}>
            {Object.entries(analysis).map(([component, details]) => {
                if (!details.expected) return null;

                return (
                    <div key={component} className="flex items-start justify-between">
                        <div className="flex-1">
                            <span className="font-medium capitalize">{component}:</span>
                            {details.found ? (
                                <span className={`ml-1 ${statusColors.success}`}>
                                    ✓ Found ({details.confidence}%)
                                </span>
                            ) : (
                                <span className={`ml-1 ${statusColors.error}`}>
                                    ✗ Missing
                                </span>
                            )}
                        </div>
                        {details.found && details.actual && (
                            <div className={`ml-2 text-right max-w-xs truncate ${statusColors[statusType]}`}>
                                {Array.isArray(details.actual) ?
                                    details.actual.length + " items" :
                                    details.actual.toString().substring(0, 30)
                                }
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
